import { render } from "./ClaimPayments.vue?vue&type=template&id=e7da9c72"
import script from "./ClaimPayments.vue?vue&type=script&lang=js"
export * from "./ClaimPayments.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\c.turnbull.VT\\Documents\\GitHub\\vars-portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__